import { Alert, Modal } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import IAddressRemoteSelectProps from "components/AddressRremoteSelect/IAddressRemoteSelectProps";
import "./AdressRemoteSelect.css";

import { FaAddressBook } from "react-icons/fa";

import { IFamiliare } from "core/interfaces/data/IAssistitoRequest";
import AssistitoRepository from "core/data/AssistitoRepository";
import i18n from "utils/i18n";
import GeoLocationRepository from "core/data/GeoLocationRepository";
import { IGeoLocation } from "core/interfaces/data/IGeoLocationRequest";
import { DefaultOptionType } from "antd/lib/select";
import { performAsyncFunction } from "utils/AsyncFunctionUtility";

import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import { customNotification } from "components/CustomNotification/CustomNotification";
import CustomRemoteSelectInput from "components/CustomRemoteSelectInput/CustomRemoteSelectInput";
import CustomButton from "components/CustomButton/CustomButton";
import CardFamiliare from "components/CardFamiliare/CardFamiliare";
import { Enhanced } from "utils/ReactUtils";

const AddressRemoteSelect: React.FC<IAddressRemoteSelectProps> = ({ onValueChanged, addressBookTitle, placeholder, idLocation,sessionInfo,t,handleError }) => {
	
	const [options, setOptions] = useState<DefaultOptionType[]>([]);
	const [SelectValue, setSelectValue] = useState<any>([]);
	const [isFamError, setIsFamError] = useState<boolean>(false);
	const [showAderssbook, setShowAderssbook] = useState<boolean>(false);
	const [familiari, setFamiliari] = useState<IFamiliare[] | undefined>(undefined);

	const [familiareSelected, setFamiliareSelected] = useState<IFamiliare | undefined>(undefined);
	
	const fetchRef = useRef(0);
	

	const fetchUserList = async (location: string) => {
		const foundLocations = await GeoLocationRepository.getGeoLocationByDescription({
			IdSessione: sessionInfo.sessione!.idSessione,
			culture: i18n.language,
			Location: location,
		});

		if (foundLocations)
			return foundLocations
				.filter((loc: IGeoLocation) => {
					return loc.Address.PostCode;
				})
				.map((loc: IGeoLocation) => {
					var locationDescription = loc.Address.Road ?? "";
					locationDescription = locationDescription + (loc.Address.HouseNumber ? " " + loc.Address.HouseNumber : "");
					locationDescription = (locationDescription ? locationDescription + ", " : "") + (loc.Address.Village ?? loc.Address.County);
					locationDescription = (locationDescription ? locationDescription + ", " : "") + loc.Address.PostCode;
					if (loc.Address.Village !== null) locationDescription = (locationDescription ? locationDescription + ", " : "") + loc.Address.County;
					locationDescription = (locationDescription ? locationDescription + "(" : "") + loc.Address.CountryCode.toUpperCase() + ")";

					return {
						label: locationDescription,
						value: loc.UniqueId + "|" + loc.Address.PostCode,
					};
				});
	};

	const getFamiliari = useCallback(async () => {
		try {
			const familiari = await AssistitoRepository.GetFamiliari({
				IdSessione: sessionInfo.sessione!.idSessione,
				culture: i18n.language,
			});
			return familiari;
		} catch (err: any) {
			setIsFamError(true);
		}
	}, [sessionInfo]);

	useEffect(() => {
		if (sessionInfo.isLogged && !familiari) {
			performAsyncFunction(async () => {
				var fam = await getFamiliari();
				setFamiliari(fam);
			}, handleError);
		}
	}, [familiari, getFamiliari, handleError, sessionInfo.isLogged]);

	useEffect(() => {
		var selectedValueLocation = SelectValue?.value?.split("|")[0];
		if (idLocation !== selectedValueLocation && !idLocation) {
			setOptions([]);
			setSelectValue(undefined);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [idLocation]);

	const OnClickCard = (id: any) => {
		if (familiareSelected?.Matricola === id) setFamiliareSelected(undefined);
		else setFamiliareSelected(familiari?.filter((el) => parseInt(el.Matricola) === parseInt(id))[0]);
	};

	const populateAdressFromFamigliare = () => {
		if (familiareSelected?.CapDomicilio && familiareSelected.IstatDomicilio && familiareSelected.IndirizzoDomicilio) {
			var res = [
				{
					label: `${familiareSelected.IndirizzoDomicilio}, ${familiareSelected.CapDomicilio}, ${familiareSelected.ComuneDomicilio}`,
					value: "|" + familiareSelected.CapDomicilio,
				},
			];
			setOptions(res);
			if (onValueChanged) onValueChanged(res[0]?.value);
			setSelectValue(res[0]);
			setShowAderssbook(false);
			setFamiliareSelected(undefined);
		} else {
			performAsyncFunction(async () => {
				fetchRef.current += 1;
				const fetchId = fetchRef.current;
				setOptions([]);

				await fetchUserList(familiareSelected?.IndirizzoDomicilio ?? familiareSelected?.IndirizzoResidenza!).then(
					(newOptions: { label: string; value: string }[] | undefined) => {
						if (fetchId !== fetchRef.current) {
							// for fetch callback order
							return;
						}
						if (newOptions) {
							setOptions(newOptions);
							if (newOptions.length === 0) {
								openNotificationNoAdressFound();
							}
							if (onValueChanged) onValueChanged(newOptions[0]?.value);
							setSelectValue(newOptions[0]);
						}
						setShowAderssbook(false);
						setFamiliareSelected(undefined);
					}
				);
			}, handleError);
		}
	};

	const openNotificationNoAdressFound = () => {
		customNotification(t("adressNotFound.title"), t("adressNotFound.message"), "info", undefined, "top");
	};

	return (
		<div className={"adressRemoteSelectInput" + (sessionInfo.isLogged ? " user-logged" : "")}>
			<CustomRemoteSelectInput
				size="large"
				allowClear={true}
				dropdownMatchSelectWidth={false}
				placeholder={placeholder}
				fetchOptions={fetchUserList}
				className="domicilioSelector"
				debounceTimeout={800}
				maxTagAllowed={1}
				onValueChanged={onValueChanged}
				options={options}
				setOptions={setOptions}
				selectValue={SelectValue}
				setSelectValue={setSelectValue}
			/>

			{sessionInfo.isLogged ? (
				<>
					<CustomButton
						text={""}
						style={{ marginLeft: "5px" }}
						icon={<FaAddressBook />}
						OnClick={() => {
							setShowAderssbook(true);
						}}
						buttonType={CustomButtonType.positive}
					/>

					<Modal
						open={showAderssbook}
						title={addressBookTitle}
						onCancel={() => {
							setShowAderssbook(false);
						}}
						onOk={populateAdressFromFamigliare}
					>
						{isFamError ? (
							<Alert message={t("errorMessages.base")} type="error" showIcon banner />
						) : (
							<div className="customSelect-famigliari">
								{familiari?.map((familiare, index) => {
									return (
										<div className={`card-container ${familiare.UtenteIsRichiedente ? "user-is-assisted" : ""}`} key={familiare.Matricola}>
											<CardFamiliare
												familiare={familiare}
												OnClick={OnClickCard}
												selected={familiareSelected}
												key={index}
												showAddressDetails={true}
												useAvatar={true}
											/>
										</div>
									);
								})}
							</div>
						)}
					</Modal>
				</>
			) : (
				<></>
			)}
		</div>
	);
}; // Usage of DebounceSelect

export default Enhanced( AddressRemoteSelect,{componentNamespace:"AddressRemoteSelect"});
